import { render, staticRenderFns } from "./NevronTableModalGeneric.vue?vue&type=template&id=0d8beaa2&scoped=true&v-on-clickaway=cancel&"
import script from "./NevronTableModalGeneric.vue?vue&type=script&lang=ts&"
export * from "./NevronTableModalGeneric.vue?vue&type=script&lang=ts&"
import style0 from "./NevronTableModalGeneric.vue?vue&type=style&index=0&id=0d8beaa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8beaa2",
  null
  
)

export default component.exports